interface LogoProps {
  compact?: boolean;
  onDark?: boolean;
}

export function Logo({ compact = false, onDark = false }: LogoProps) {
  return (
    <div
      className={`brand ${compact ? "brand--compact" : ""}`}
      aria-label="RestLab"
    >
      <img
        src={
          onDark
            ? "/brand/restlab-logo-on-dark.png"
            : "/brand/restlab-logo.png"
        }
        alt=""
        aria-hidden="true"
      />
    </div>
  );
}
